import React, { useState, useEffect, Fragment } from 'react'
import Cookies from 'universal-cookie';
import {
    Typography, Paper, Button, Accordion, AccordionSummary, AccordionDetails,
    Table, TableHead, TableRow, TableCell, TableBody, TableContainer,
    Badge, Grid, Box, FormControlLabel, Checkbox,
    TextField, Alert, LinearProgress
} from '@mui/material'
import 'dayjs/locale/es';
import html2pdf from 'html2pdf.js';
import IconButton from '@mui/material/IconButton'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import 'dayjs/locale/es'
import { CircleAlertIcon, CircleCheckBigIcon, CirclePlusIcon, Trash2Icon } from 'lucide-react'

import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import WorkFlowPage from '../../pages/WorkFlowPage'
import { setContractFull } from '../../Redux/TabDucks'
import InyeccionService from '../../services/inyeccionService'
import { setCargaDatos } from '../../Redux/GeneralDuck'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'
import Select from 'react-select'
import CustomerService from '../../services/customerService';
import Swal from 'sweetalert2';
import { layoutService } from '../../services/layoutService';
import { LobService } from '../../services/lobService';
import { InterviewService } from '../../services/interviewService';
import { use } from 'react';

const ValidaForm = () => {
    const dispatch = useDispatch()
    const contractData = useSelector((store) => store.tab.contractFull)
    const cuotasData = useSelector((store) => store.tab.Cuotas)
    const _TAB = useSelector((store) => store.tab)
    const general = useSelector((store) => store.general)

    const [HiddenAll, setHiddenAll] = useState(true);

    const [tribunales, setTribunales] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [formData, setFormData] = useState({
        identifier: '',
        firstName: '',
        lastName: '',
        email: '',
        numContrato: '',
        contractId: '',
        fechaContrato: null,
        observaciones: '',
    });
    const [linesOfBusiness, setLinesOfBusiness] = useState([]);

    const [conteo, setConteo] = useState({ total: 0, completas: 0, sac: false, eepp: false, sesacion: false })
    const [show, setShow] = useState(false)
    const [validadoInyectado, setValidadoInyectado] = useState(false)
    const [showInitialCase, setShowInitialCase] = useState(false)
    const [showModalAddCausa, setShowModalAddCausa] = useState(false)
    const [newCase, setNewCase] = useState({ rol: '', tribunal: '', nombre: '', demandante: '' })

    const [openCausa, setOpenCausa] = useState(null)

    const [selectedCausa, setSelectedCausa] = useState({ servicio: null, causa: null, groupId: null, contado: false });
    const [causasList, setCausasList] = useState([]);

    const [selectedTasksCase, setSelectedTasksCase] = useState({}); // Inicialmente vacío
    const [selectedTasks, setSelectedTasks] = useState([]); // Inicialmente vacío
    const [selectedTasksEEPP, setSelectedTasksEEPP] = useState([]);
    const [IsEEPP, setIsEEPP] = useState(false);

    /** TAREAS  en public task.js*/
    const [SAC_TASK, setSAC_TASK] = useState([])
    const [User_SAC, setUser_SAC] = useState([])
    const [EEPP_TASK, setEEPP_TASK] = useState([])
    const [User_EEPP, setUser_EEPP] = useState([])
    const [CASE_TASK, setCASE_TASK] = useState([])
    const [User_CASES, setUser_CASES] = useState([])


    useEffect(() => {
        setSAC_TASK(window.SAC_TASK)
        setUser_SAC(window.USER_SAC)
        setEEPP_TASK(window.EEPP_TASK)
        setUser_EEPP(window.USER_EEPP)
        setCASE_TASK(window.CASE_TASK)
        setUser_CASES(window.USER_CASES)

        dispatch(setCargaDatos())
    }, [])

    const [finiquitado, setFiniquitado] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [bloquearAcciones, setBloquearAcciones] = useState(false);

    useEffect(() => {
        if (_TAB.contractFull?.cancel == true) {
            setCancelado(true)
            setBloquearAcciones(true)
        }
        if (_TAB.contractFull?.finiquitado == true) {
            setFiniquitado(true)
            setBloquearAcciones(true)
        }
    }, [_TAB])


    useEffect(() => {
        const fetchInitialData = async () => {
            const contrato = await LobService.getCustomerContract(contractData.rut, contractData.numContratos);
            setHiddenAll(false)

            const saclist = await InyeccionService.getTasks("sac", contrato.contract.id)
            if (saclist != null && saclist.length > 0)
                setSelectedTasks(saclist)

            const eeppList = await InyeccionService.getTasks("eepp", contrato.contract.id)
            if (eeppList != null && eeppList.length > 0) {
                setIsEEPP(true)
                setSelectedTasksEEPP(eeppList)
            }

            const casetasks = await InyeccionService.getTasksCase(contrato.contract.id)
            if (casetasks != null && casetasks != "") {
                setSelectedTasksCase(casetasks)
            }



            setFormData({
                identifier: contrato.customer.identifier || '',
                firstName: contrato.customer.firstName || '',
                lastName: contrato.customer.lastName || '',
                email: contrato.customer.email || '',
                numContrato: contrato.contract.numContrato || '',
                contractId: contrato.contract.id || '',
                fechaContrato: contrato.contract.fechaContrato ? new Date(contrato.contract.fechaContrato) : null,
                observaciones: contrato.customer.observaciones || '',
            });

            setLinesOfBusiness(contrato.contract.contract_Line || []);
        }
        fetchInitialData();
    }, [])


    useEffect(() => {
        var total = 0
        var completas = 0

        if (contractData?.numContratos && contractData.rut) {
            var _sesacion = false
            contractData.negocios.forEach(linea => {
                linea.servicios.forEach(servicios => {
                    const causas = servicios.causas || []
                    total += causas.length // Contar todas las causas
                    completas += causas.filter(c => c.idStatus === 2).length
                    _sesacion = servicios.name == "Cesación de Pago" ? true : false
                })
            })

            setConteo({ total, completas, sac: false, eepp: false, sesacion: _sesacion })
        }
    }, [contractData])


    useEffect(() => {
        if (general.tribunales.length > 0)
            setTribunales(general.tribunales.map((item) => {
                return { value: item.value, label: item.label }
            }))

        if (general.grupos.length > 0)
            setGrupos(general.grupos.map((item) => {
                return { value: item.id, label: item.description }
            }))
    }, [general])

    const opt = {
        margin: 10,
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.8 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };


    const openInitialCase = (causa, servicio) => {
        setCausasList(prev => {
            const key = `${causa.id}-${servicio}`;
            const causaIndex = prev.findIndex(c => `${c.id}-${c.servicio}` === key);
            if (causaIndex !== -1) {
                const existingCausa = prev[causaIndex];
                setSelectedCausa({
                    servicio: existingCausa.servicio,
                    causa: existingCausa,
                    contado: existingCausa.idStatus == 2,
                    groupId: existingCausa.groupId || null,
                });
                return prev;
            } else {
                const newCausa = { ...causa, servicio: servicio };
                setSelectedCausa({
                    servicio: servicio,
                    causa: newCausa,
                    contado: newCausa.idStatus == 2,
                    groupId: null,
                });
                return [...prev, newCausa];
            }
        });

        // Si la causa ya tiene tareas seleccionadas, las cargamos; si no, inicializamos vacías

        setSelectedTasksCase((prevState) => ({
            ...prevState,
            [`${causa.id}-${servicio}`]: prevState[`${causa.id}-${servicio}`] || [],
        }));

        setShowInitialCase(true);
    };

    const handleGroupChangeCase = (event) => {

        setCausasList(prev => {
            const key = `${selectedCausa.causa.id}-${selectedCausa.servicio}`;
            const causaIndex = prev.findIndex(c => `${c.id}-${c.servicio}` === key);
            if (causaIndex !== -1) {
                const updatedCausas = [...prev];
                updatedCausas[causaIndex] = { ...updatedCausas[causaIndex], groupId: event.value };
                return updatedCausas;
            } else {
                return [...prev, { ...selectedCausa.causa, servicio: selectedCausa.servicio, groupId: event.value }];
            }
        });

        setSelectedCausa((prevState) => ({
            ...prevState,
            causa: { ...prevState.causa, groupId: event.value },
        }));
    };

    const handleSave = async (causa) => {
        if (!selectedCausa.causa) return;

        if (!selectedCausa.causa.groupId) {
            Swal.fire({
                title: 'No Agrego el Grupo',
                allowOutsideClick: true,
            })
            return;
        }

        var caseSend = {
            CausasContratoId: selectedCausa.causa.id,
            groupId: selectedCausa.causa.groupId,
            idStatus: 2,
            contractServiceId: selectedCausa.causa.contractServiceId,
            contractId: contractData.contractId,
            selectedTasksCase: JSON.stringify(selectedTasksCase[`${selectedCausa.causa.id}-${selectedCausa.servicio}`] || []),
            nameTasksCase: `${selectedCausa.causa.id}-${selectedCausa.servicio}`,
        }

        var savTaskListCase = await InyeccionService.addCausaListValidate(caseSend)

        // Aquí puedes almacenar las tareas seleccionadas en el backend
        selectedCausa.causa.idStatus = 2; // Marcar como validada
        if (!selectedCausa.contado) {
            selectedCausa.contado = true;
            setConteo((prevConteo) => { //se suma al conteo si no esta completa
                return { ...prevConteo, completas: prevConteo.completas + 1 };
            });
        }

        setCausasList(prev => {
            const key = `${selectedCausa.causa.id}-${selectedCausa.servicio}`;
            const causaIndex = prev.findIndex(c => `${c.id}-${c.servicio}` === key);
            if (causaIndex !== -1) {
                const updatedCausas = [...prev];
                updatedCausas[causaIndex] = { ...selectedCausa.causa, servicio: selectedCausa.servicio };
                return updatedCausas;
            } else {
                return [...prev, { ...selectedCausa.causa, servicio: selectedCausa.servicio }];
            }
        });

        setShowInitialCase(false); // Cierra el modal después de guardar

    }

    const handleChangeTribunales = (e) => {
        if (e) {
            const { value, label } = e;
            setNewCase((prevData) => ({
                ...prevData, codTribunal: value, tribunal: label
            }))
        } else {
            setNewCase((prevData) => ({
                ...prevData, codTribunal: null, tribunal: null
            }))
        }
    }

    const getSelectedGroupId = (causaid, servicio) => {
        const key = `${causaid}-${servicio}`;
        const causa = causasList.find(c => `${c.id}-${c.servicio}` === key);
        return causa ? causa.groupId ?? causa.legalGroupId ?? "" : "";
    };

    const buscarCausaPorId = (id) => {
        for (const linea of contractData.negocios) {
            for (const servicio of linea.servicios) {
                const causa = servicio.causas.find((c) => c.id === id)
                if (causa) {
                    return causa
                }
            }
        }
        return null
    }

    const onclickWorkflowValidado = async (workflow, InCausa) => {

        if (InCausa.id === openCausa.id) {
            var auxCausa = openCausa
            var auxContractData = contractData
            auxCausa.cosmosId = workflow.cosmosId
            auxCausa.legalGroupId = workflow.GroupId
            auxCausa.legalServiceId = workflow.ServiceId
            auxCausa.idStatus = 2
            auxCausa.validationDate = new Date()
            auxCausa.inyectionDate = new Date()

            // Insertar al ctto
            // Actualizar la causa en el JSON

            auxContractData.negocios.forEach(ln => {
                ln.servicios.forEach(servicio => {
                    servicio.causas.forEach((c, index) => {
                        if (c.id === auxCausa.id) {
                            // Reemplazar la causa
                            servicio.causas[index] = { ...auxCausa }
                        }
                    })
                })
            })

            dispatch(setContractFull(auxContractData)) // para llenar el tab
            //     await CustomerService.validarCausasContrato(auxCausa)
        }

    }

    const GenerateDataToSubmit = () => {
        return {
            contract: {
                contratoId: contractData.contractId,
                identifier: contractData.rut,
                numContrato: contractData.numContratos,
                firstName: contractData.nombre,
                observaciones: contractData.observaciones,
                fechaContrato: contractData.fechaNegocio,
                HA: _TAB.interview.content,
            },
            payingCustomerId: contractData.pagador.id,
            linesOfBusiness: contractData.negocios.map(negocio => {
                var cuota = cuotasData.find(cuota => cuota.contractLineId === negocio.id)
                return {
                    idBusiness: negocio.lineId,
                    paymentMethod: cuota.metodoPagoId,
                    firstPaymentDate: cuota.fechaPrimerPago,
                    numberOfInstallments: cuota.numeroCuotas,
                    montoTotal: cuota.pagoCuotas.reduce((total, pc) => total + pc.monto, 0),
                    documentURl: negocio.urlS3,
                    installments: cuota.pagoCuotas.map(pc => {
                        return {
                            number: pc.numeroCuota,
                            date: pc.fechaCuota,
                            amount: pc.monto,
                        }
                    })
                }

            })
        }
    }

    const InyectarContratoValidado = async () => {
        var sendInyectionLegal = {}
        var total = 0
        var completas = 0
        const cookies = new Cookies()
        const username = cookies.get('userName')
        const useremail = cookies.get('userEmail')
        var contratos = []

        if (contractData?.numContratos && contractData.rut) {
            contractData.negocios.forEach(linea => {
                linea.servicios.forEach(servicios => {
                    const causas = servicios.causas || []
                    total += causas.length // Contar todas las causas
                    completas += causas.filter(c => c.idStatus === 2).length
                })
            })
        }
        if (validarConteo()) {
            var client = {
                identifier: _TAB.customerFormatted.rut,
                name: _TAB.customerFormatted.firstName + ' ' + _TAB.customerFormatted.lastName,
                email: _TAB.customerFormatted.email,
                claveUnica: _TAB.customerFormatted.claveUnica,
                telephone: _TAB.customerFormatted.phone,
                address: _TAB.customerFormatted.address,
                idGenero: _TAB.customerFormatted.genero,
                idEstadoCivil: _TAB.customerFormatted.estadoCivil,
                observations: _TAB.customerFormatted.observations,
                idBranch: _TAB.customerFormatted.sucursal,
                idCountry: _TAB.customerFormatted.country,
                idRegion: _TAB.customerFormatted.region
            }

            var cases = []

            contratos.push(GenerateDataToSubmit())

            contractData.negocios.forEach(negocio => {
                negocio.servicios.forEach(servicio => {
                    servicio.causas.forEach(causa => {
                        const tasksCase = Object.keys(selectedTasksCase).find(key => {
                            const [causaId, servicioName] = key.split('-');
                            return causaId === causa.id.toString() && servicioName === servicio.name;
                        });
                        const tasks = tasksCase ? selectedTasksCase[tasksCase] : [];
                        const key = `${causa.id}-${servicio.name}`;
                        const causafind = causasList.find(c => `${c.id}-${c.servicio}` === key) || causa;

                        cases.push({
                            caseIdGcc: causa.id ?? 0,
                            contractServiceId: causa.contractServiceId,
                            rol: causa.rol,
                            title: causa.nombre,
                            groupId: causafind.groupId ?? causa.groupId ?? causa.legalGroupId,
                            serviceId: causa.legalServiceId,
                            tribunalId: causa.codTribunal,
                            lineaNegocioSigla: negocio.description,
                            cosmosId: causa.cosmosId,
                            codCtto: negocio.codCtto,
                            taskCase: tasks // Añadir la lista de tareas
                        })
                    })
                })
            })

            sendInyectionLegal = {
                client,
                cases,
                creatorName: username,
                creatorEmail: useremail,
                tasksSac: selectedTasks,
                isEEPP: IsEEPP,
                tasksEepp: IsEEPP ? selectedTasksEEPP : [],
                contratos
            };

            var responseInyectionLegal = await InyeccionService.injectionLegalV1(sendInyectionLegal)

            return { status: responseInyectionLegal.status, sendInyectionLegal, responseInyectionLegal }
        }
        return { status: false, sendInyectionLegal, responseInyectionLegal: null }
    }

    const InyectarCuotasManager = async () => {
        const _pagador = contractData.pagador
        contractData.dataToSubmit = GenerateDataToSubmit()
        const _Cuotas = contractData.dataToSubmit.linesOfBusiness
        var Pagares = []

        _Cuotas.forEach(element => {
            var negocio = contractData.negocios.find(x => x.lineId === element.idBusiness)
            Pagares.push({
                ContractId: contractData.contractId,
                CodCtto: contractData.negocios.find(n => n.description === negocio.description).codCtto,
                LineaNegocio: {
                    Id: negocio.id,
                    Description: negocio.description,
                    Name: negocio.name,
                    Siglas: negocio.siglas,
                },
                CuotasLinea: element.installments.map(i => ({
                    number: i.number,
                    date: i.date,
                    amount: String(i.amount)
                }))
            })

        });
        const Data = {
            Pagador: {
                Rut: _pagador.identifier,
                PrimerNombre: _pagador.firstName,
                SegundoNombre: '',
                PrimerApellido: _pagador.lastName,
                SegundoApellido: '',
                Email: `${_pagador.email.toString().toLowerCase()}`,
                Calle: _pagador.address,
                Celular: _pagador.telephone,
                Pais: general.paises.find(p => p.id === _pagador.idCountry).description,
                Region: general.regiones.find(r => r.id === _pagador.idRegion).description,
                Comuna: general.comunas.find(r => r.id === _pagador.idDistrito).description,
                Genero: general.generos.find(r => r.id === _pagador.idGenero).description,
                EstadoCivil: general.estadoCivil.find(r => r.id === _pagador.idEstadoCivil).description,
                Pyme: _pagador.idTipoPersona === 0 ? 'NO' : 'SI',
                Tipo: _pagador.idTipoPersona === 0 ? 'Particular' : 'Empresa',
                Sucursal: _TAB.Sucursales.find(x => x.id === _TAB.customerFormatted.sucursal).description,
                TypeContract: 'VO',//VO o VP  virtual o presencial
                FechaNacimiento: '',
                Telefono: '',
                Ocupacion: '',
                Numero: '',
                Depto: '',
                Provincia: '',//general.provincias.find(r => r.id == _pagador.idProvince).description,
            },
            Pagares
        }
        return await InyeccionService.cargarCuotas(Data)
    }

    const ReplaceAllTags = (texto, index) => {
        var _f = extraerFecha(formData.fechaContrato) || ""

        var cuotas = linesOfBusiness[index].cuotas.length > 0 ? generarTablaCuotas(linesOfBusiness[index].cuotas[0]?.pagoCuotas) : ''
        var acreedores = generarTablaAcreedores(index)
        let totalAmount = `$ ${linesOfBusiness[index].contractServices.reduce((total, service) => total + (service.amount || 0), 0)}` || ""

        console.log(_TAB)
        console.log(texto)

        texto = texto.replace(/@sucursal/g, _TAB.Sucursales?.find(x => x.id == _TAB.customerFormatted.sucursal)?.name || "@sucursal")
        texto = texto.replace(/@codigo_contrato/g, linesOfBusiness[index].codCtto?.trim() || "@codigo_contrato")
        texto = texto.replace(/@tipo_fuente/g, linesOfBusiness[index].codCtto?.trim() || "@tipo_fuente")
        texto = texto.replace(/@dia_entrevista/g, _f.dia?.trim() || "@dia_entrevista")
        texto = texto.replace(/@mes_entrevista/g, _f.mesTexto?.trim() || "@mes_entrevista")
        texto = texto.replace(/@anio_entrevista/g, _f.año?.trim() || "@anio_entrevista")
        texto = texto.replace(/@nombre_pagador/g, `${_TAB.contractFull.pagador?.firstName?.trim() || ""} ${_TAB.contractFull.pagador?.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
        texto = texto.replace(/@rut_pagador/g, _TAB.contractFull.pagador?.identifier?.trim() || "@rut_pagador")
        texto = texto.replace(/@estado_civil_pagador/g, general.estadoCivil?.find(x => x.id == _TAB.contractFull.pagador?.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
        texto = texto.replace(/@ocupacion_pagador/g, _TAB.contractFull.pagador?.ocupacion?.trim() || "@ocupacion_pagador")
        texto = texto.replace(/@ocupacion_pagaddor/g, _TAB.contractFull.pagador?.ocupacion?.trim() || "@ocupacion_pagaddor")
        texto = texto.replace(/@direccion_pagador/g, _TAB.contractFull.pagador?.address?.trim() || "@direccion_pagador")
        texto = texto.replace(/@comuna_pagador/g, general.comunas?.find(x => x.id == _TAB.contractFull.pagador?.idDistrito)?.description?.trim() || "@comuna_pagador")
        texto = texto.replace(/@comuna_pagado/g, general.comunas?.find(x => x.id == _TAB.contractFull.pagador?.idDistrito)?.description?.trim() || "@comuna_pagado")
        texto = texto.replace(/@region_pagador/g, general.regiones?.find(x => x.id == _TAB.contractFull.pagador?.idRegion)?.description?.trim() || "@region_pagador")
        texto = texto.replace(/@telefono_pagador/g, _TAB.contractFull.pagador?.telephone?.trim() || "@telefono_pagador")
        texto = texto.replace(/@celular_pagador/g, _TAB.contractFull.pagador?.telephone?.trim() || "@celular_pagador")
        texto = texto.replace(/@email_pagador/g, _TAB.contractFull.pagador?.email?.trim() || "@email_pagador")
        texto = texto.replace(/@firmas/g, "")//"@firmas"
        texto = texto.replace(/@nacionalidad_pagador/g, general.paises?.find(x => x.id == _TAB.contractFull.pagador?.idCountry)?.description?.trim() || "@nacionalidad_pagador")
        texto = texto.replace(/@origen/g, _TAB.interview?.origen?.toUpperCase().trim() || "REMOTO")
        texto = texto.replace(/@porcentajes/g, "@porcentajes")
        texto = texto.replace(/@cuotas/g, cuotas?.trim() || "@cuotas")
        texto = texto.replace(/@acreedores/g, acreedores || "@acreedores")
        texto = texto.replace(/@defensavictimas/g, "@defensavictimas")
        texto = texto.replace(/@fecha_texto_fin/g, "@fecha_texto_fin")
        texto = texto.replace(/@fecha_act_texto/g, "@fecha_act_texto")
        texto = texto.replace(/@h_acreedores/g, "@h_acreedores")
        texto = texto.replace(/@defensafamilia/g, "@defensafamilia")
        texto = texto.replace(/@nombre_empresa_pyme/g, "@nombre_empresa_pyme")
        texto = texto.replace(/@defensafamilias/g, "@defensafamilias")
        texto = texto.replace(/@servicios/g, "@servicios")
        texto = texto.replace(/@total_ccontrato/g, totalAmount.trim() || "@total_ccontrato")
        texto = texto.replace(/@toral_contrato/g, totalAmount.trim() || "@toral_contrato")
        texto = texto.replace(/@total_contrato/g, totalAmount.trim() || "@total_contrato")
        texto = texto.replace(/@fi/g, "@fi")
        return texto;
    }

    const HandleInyeccion = async () => {
        if (contractData?.dealHubspotId == null || contractData?.dealHubspotId == undefined || contractData?.dealHubspotId == "") {
            Swal.fire({
                position: "center",
                icon: "warning",
                title: "Falta Negocio de Hubspot",
                title: "Agregar Negocio de Hubspot en la ventana de entrevista",
            })
            return
        }

        if (contractData.hubspotInyectionSend == false) {
            var sfireHB = Swal.fire({
                title: 'Inyectando a Hubspot ...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            })
            var resultHb = await CustomerService.insertHubspotDealId({
                id: contractData.dealHubspotId ?? _TAB.interview.dealHubspotId,
                codCtto: contractData.negocios[0].codCtto,
                amount: contractData.negocios[0].servicios.reduce((acc, servicio) => acc + servicio.costo, 0),
                contractId: contractData.contractId,
                motivo: 'Contrato Validado'
            })

            sfireHB.close()

            if (resultHb) {
                const updatedContractData = { ...contractData };
                updatedContractData.hubspotInyectionSend = resultHb
                dispatch(setContractFull(updatedContractData));
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Negocio actualizado en Hubspot",
                    showConfirmButton: true,
                    timer: 2000,
                });
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Negocio no fue Actualizado en Hubspot, comuniquese con el administrador",
                    showConfirmButton: true,
                    timer: 2000,
                });
            }
        }



        if (contractData.managerInyectionSend == false) {
            var sfireMan = Swal.fire({
                title: 'Inyectando a Manager ...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            })

            var resultMan = await InyectarCuotasManager()
            sfireMan.close()
            if (resultMan) {
                const updatedContractData = { ...contractData };
                updatedContractData.managerInyectionSend = resultMan
                dispatch(setContractFull(updatedContractData));
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Cuotas enviadas a Manager",
                    showConfirmButton: true,
                    timer: 2000,
                });
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Cuotas no fueron enviadas a Manager, comuniquese con el administrador",
                    showConfirmButton: true,
                    timer: 2000,
                });
            }
        }


        if (contractData.legalInyectionSend == false) {
            var sfireLegal = Swal.fire({
                title: 'Inyectando a Legal365 ...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            })

            var response = await InyectarContratoValidado()

            await InyeccionService.ConfirmInyectionLegal(contractData.contractId, response.status, response.responseInyectionLegal, response.sendInyectionLegal)

            sfireLegal.close()
            const updatedContractData = { ...contractData };
            updatedContractData.managerInyectionSend = response.status
            dispatch(setContractFull(updatedContractData));
            if (response.status)
                setValidadoInyectado(true)
        }


        if (contractData.mailSends == false) {
            var sfireMail = Swal.fire({
                title: 'Enviado correos al Cliente ...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            })

            var resultSendMail = await InyeccionService.SendClientMails({
                type: 1,
                Identifier: contractData.rut,
                ContratoBase64: await html2pdf().set(opt).from(ReplaceAllTags(contractData.negocios[0].html, 0)).outputPdf('datauristring'),
                ConsentimientoBase64: await ShowConsentimiento(contractData.negocios[0].servicios[0].id)
            })
            await InyeccionService.ConfirmSendMail(contractData.contractId, resultSendMail.html, resultSendMail.success)//uwu
            sfireMail.close()
            const updatedContractData = { ...contractData };//holi
            updatedContractData.mailSends = resultSendMail.success
            dispatch(setContractFull(updatedContractData));
        }
    }

    const ShowConsentimiento = async (idService) => {
        try {
            // Llamada al servicio para obtener los datos
            const data = await layoutService.getLayoutByServiceId(idService);


            const tempElement = document.createElement('div');
            tempElement.innerHTML = data.layoutContent;
            //document.body.appendChild(tempElement);

            var aux = opt
            aux.filename = "Consentimiento.pdf"
            return await html2pdf().set(aux).from(tempElement).outputPdf('datauristring')

        } catch (error) {
            //alert(JSON.stringify(error))
            //setError('Error al obtener las cuotas del contrato.');
        }
        return null
    }

    const ShowAddCausa = (linea, servicio, contractServiceId) => {
        setNewCase({ rol: '', tribunal: '', nombre: '', demandante: '', linea, servicio, contractServiceId })
        setShowModalAddCausa(true)
    }

    const ShowDeleteCausa = (causaId) => {
        Swal.fire({
            title: '¿Está seguro que desea eliminar la causa?',
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                var success = await CustomerService.deleteCausaContractValidate({ causaId })
                if (success) {
                    var interview = await InterviewService.getCustomerInterviewId(_TAB.interview.id)
                    dispatch(setContractFull(interview.contract))
                    setShowModalAddCausa(false);
                    Swal.fire('Eliminado', 'La causa ha sido eliminada.', 'success');
                }
                else return;
            }
        });
    }

    const handleChange = (e) => {
        setNewCase({ ...newCase, [e.target.name]: e.target.value })
    }

    const onClickAddCausa = async () => {
        const updatedContractData = { ...contractData };
        var sendCausa = {}
        updatedContractData.negocios.forEach((negocio) => {
            if (negocio.name === newCase.linea) {
                negocio.servicios.forEach((servicio) => {
                    if (servicio.name === newCase.servicio) {
                        const newCausa = {
                            rol: newCase.rol,
                            tribunal: newCase.tribunal,
                            codTribunal: newCase.codTribunal,
                            nombre: newCase.nombre,
                            demandante: newCase.demandante,
                            contractServiceId: servicio.contractServiceId
                        };
                        sendCausa = newCausa
                    }
                });
            }
        });

        var success = await CustomerService.addCausaContractValidate(sendCausa)
        if (success) {
            var interview = await InterviewService.getCustomerInterviewId(_TAB.interview.id)
            dispatch(setContractFull(interview.contract))
            setShowModalAddCausa(false);
        }
    }

    useEffect(() => {
        // alert(conteo.sesacion)
    }, [conteo])

    const validarConteo = () => {
        if (contractData.legalInyectionSend) return true
        if (conteo.total === 0 && !conteo.sesacion) return false
        if (conteo.total !== conteo.completas) return false
        if (conteo.sac === false) return false
        if (IsEEPP && conteo.eepp === false) return false

        return true;
    }


    const handleCheckboxChangeCase = (event, task, causaId, servicio) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaId}-${servicio}`;
            const existingTasks = prevState[key] || [];

            if (event.target.checked) {
                // Agregar tarea seleccionada con nombre, usuario vacío y descripción
                return {
                    ...prevState,
                    [key]: [...existingTasks, { name: task.name, description: task.description, extra: "", userId: 0 }],
                };
            } else {
                // Remover tarea deseleccionada
                return {
                    ...prevState,
                    [key]: existingTasks.filter((t) => t.name !== task.name),
                };
            }
        });
    };

    const handleUserChangeCase = (event, taskName, causaId, servicio) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaId}-${servicio}`;
            const prevTasks = prevState[key] || []; // Asegura que siempre sea un array

            return {
                ...prevState,
                [key]: prevTasks.map((t) =>
                    t.name === taskName ? { ...t, userId: Number(event.target.value) } : t
                ),
            };
        });
    };

    const handleExtraChangeCase = (event, taskName, causaId, servicio) => {
        setSelectedTasksCase((prevState) => {
            const key = `${causaId}-${servicio}`;
            const prevTasks = prevState[key] || []; // Asegura que siempre sea un array

            return {
                ...prevState,
                [key]: prevTasks.map((t) =>
                    t.name === taskName ? { ...t, extra: event.target.value } : t
                ),
            };
        });
    };


    const handleCheckboxChange = (event, task) => {
        const { checked } = event.target;

        setSelectedTasks(prevTasks => {
            if (checked) {
                // Si se marca, agregar la tarea al array
                return [...prevTasks, { name: task.name, description: task.description, extra: "", userId: 0 }];
            } else {
                // Si se desmarca, eliminar del array
                return prevTasks.filter(t => t.name !== task.name);
            }
        });
    };

    const handleUserChange = (event, taskName) => {
        const { value } = event.target;

        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, userId: Number(value) } : task
            )
        );
    };

    const handleExtraChange = (event, taskName) => {
        const { value } = event.target;

        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, extra: value } : task
            )
        );
    };

    const countTasksWithNullUsers = () => {
        if (selectedTasks.length > 0) {
            const sacTasksWithNullUsers = selectedTasks.filter(task => task.userId === null).length;
            setConteo(prevConteo => ({
                ...prevConteo,
                sac: sacTasksWithNullUsers === 0
            }));
        }
    };

    const extraerFecha = (fechaContrato) => {
        let fecha = new Date(fechaContrato);

        let dia = fecha.getDate().toString().trim() || "<span style='background-color:orange'>@dia_entrevista</span>";

        let meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
        let mesTexto = meses[fecha.getMonth()].trim() || "<span style='background-color:orange'>@mes_entrevista</span>";

        let año = fecha.getFullYear().toString().trim() || "<span style='background-color:orange'>@año_entrevista</span>";

        return { dia, mesTexto, año };
    }

    const handleCheckboxChangeEEPP = (event, task) => {
        const { checked } = event.target;

        setSelectedTasksEEPP(prevTasks => {
            if (checked) {
                // Si se marca, agregar la tarea al array
                return [...prevTasks, { name: task.name, description: task.description, extra: "", userId: 0 }];
            } else {
                // Si se desmarca, eliminar del array
                return prevTasks.filter(t => t.name !== task.name);
            }
        });
    };

    const handleExtraChangeEEPP = (event, taskName) => {
        const { value } = event.target;

        setSelectedTasksEEPP(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, extra: value } : task
            )
        );
    };

    const handleUserChangeEEPP = (event, taskName) => {
        const { value } = event.target;

        setSelectedTasksEEPP(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, userId: Number(value) } : task
            )
        );
    };

    const countTasksEEPPWithNullUsers = () => {
        if (selectedTasksEEPP.length > 0) {
            const eeppTasksWithNullUsers = selectedTasksEEPP.filter(task => task.userId === null).length;
            setConteo(prevConteo => ({
                ...prevConteo,
                eepp: eeppTasksWithNullUsers === 0
            }));
        }
    };

    useEffect(() => {
        countTasksWithNullUsers();
    }, [selectedTasks]);

    useEffect(() => {
        countTasksEEPPWithNullUsers();
    }, [selectedTasksEEPP]);

    const generarTablaCuotas = (cuotas) => {

        if (!Array.isArray(cuotas) || cuotas.length === 0) {
            return "<p style='color: red;'>No hay datos disponibles.</p>";
        }

        let tabla = `
          <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
            <thead>
              <tr>
                <th>N° Cuota</th>
                <th>Fecha</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>`;

        // Función para convertir la fecha al formato "22 de enero de 2025"
        function formatearFecha(fechaISO) {
            if (!fechaISO) return "<span style='background-color:orange'>Fecha no disponible</span>";
            let fecha = new Date(fechaISO);
            let dia = fecha.getDate();
            let mes = fecha.getMonth() + 1; //meses[fecha.getMonth()];
            let año = fecha.getFullYear();
            return `${dia}/${mes.toString().padStart(2, "0")}/${año}`;
        }

        // Recorrer el array y generar las filas de la tabla
        cuotas.forEach(cuota => {
            tabla += `
          <tr>
              <td>${cuota.numeroCuota || "<span style='background-color:orange'>Sin número</span>"}</td>
              <td>${formatearFecha(cuota.fechaCuota)}</td>
              <td>${cuota.monto ? cuota.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
          </tr>`;
        });

        tabla += ` </tbody> </table> `;

        return tabla;
    }

    const generarTablaAcreedores = (index) => {

        let tabla = `
          <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
            <thead>
              <tr>
                <th>Acreedor</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>`;

        linesOfBusiness[index].contractServices.forEach((service) => {
            service.acreedores.forEach((acreedor) => {
                tabla += `
          <tr>
              <td>${acreedor.demandante}</td>
              <td>${acreedor.monto ? acreedor.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
          </tr>`;
            });
        });

        return tabla + ` </tbody> </table> `;
    }

    const saveTask = (type) => async () => {
        var listTask = []

        if (type === "sac") listTask = selectedTasks
        if (type === "eepp") listTask = selectedTasksEEPP
        const result = await InyeccionService.saveTasks(listTask, type, contractData.contractId)
    }

    const saveSetIsEEPP = () => async () => {
        if (!IsEEPP == false) {
            var result = await InyeccionService.saveTasks("", "eepp", contractData.contractId)
            setSelectedTasksEEPP([])
        }
        setIsEEPP(!IsEEPP)
    }

    return (
        <Fragment>
            <Paper elevation={3} sx={{ p: 4, mt: 4 }} hidden={!HiddenAll}>
                <LinearProgress />
            </Paper>

            <Paper elevation={3} sx={{ p: 4, mt: 4 }} hidden={HiddenAll}>
                <Alert className='mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
                <Alert className='mb-4' severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>
                {contractData?.negocios?.map((linea, index) => (
                    <div key={index}>
                        <Typography variant="h5" sx={{ mb: 4 }}>Negocio: <strong>{linea.name}</strong> </Typography>
                        <Typography variant="h6" sx={{ mb: 4 }}>Validación de Causas Iniciales <strong>{conteo.completas} de {conteo.total}</strong> </Typography>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="ha-content" id="ha-header" >
                                <Typography variant="h7">Antecedentes</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h6">Cliente</Typography>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Nombre</TableCell>
                                                        <TableCell>Rut</TableCell>
                                                        <TableCell>Sucursal</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>{contractData?.nombre}</TableCell>
                                                        <TableCell>{contractData?.rut}</TableCell>
                                                        <TableCell>{_TAB.Sucursales?.find(s => s.id === _TAB?.customerFormatted?.sucursal)?.name ?? ''}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h6">Hoja de Atencion</Typography>
                                        <Typography
                                            className='p-1'
                                            component="div"
                                            dangerouslySetInnerHTML={{ __html: _TAB?.interview?.content ?? '' }}

                                        />

                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        {linea.servicios.map((servicio) => (
                            <Accordion disabled={(servicio.name == "Cesación de Pago" && (servicio.causas == null || servicio.causas.length == 0)) ? true : false}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" >
                                    <Typography variant="h7">Causas para Servicio: <strong>{servicio.name}</strong> </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Rol</TableCell>
                                                    <TableCell>Caratulado</TableCell>
                                                    <TableCell>Tibunal</TableCell>
                                                    <TableCell>Demandante</TableCell>
                                                    <TableCell>Estado</TableCell>
                                                    <TableCell>Validación</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {servicio.causas.map((causa) => {
                                                    const key = `${causa.id}-${servicio.name}`
                                                    var causaFind = causasList.find(c => `${c.id}-${c.servicio}` === key) || causa;

                                                    return (<TableRow key={causa.id}>
                                                        <TableCell>{causa.rol}</TableCell>
                                                        <TableCell>{causa.nombre}</TableCell>
                                                        <TableCell>{causa.tribunal}</TableCell>
                                                        <TableCell>{causa.demandante}</TableCell>
                                                        <TableCell>
                                                            {causaFind.idStatus === 2 ?
                                                                <Badge badgeContent={"Validada"} color="success"></Badge> :
                                                                <Badge badgeContent={"Pendiente"} color="warning"></Badge>
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            <>
                                                                <IconButton
                                                                    disabled={bloquearAcciones || contractData.legalInyectionSend}
                                                                    onClick={() => openInitialCase(causaFind, servicio.name)}
                                                                    color={causaFind.idStatus === 2 ? "success" : "warning"}>
                                                                    {causaFind.idStatus === 2 ? <CircleCheckBigIcon /> : <CircleAlertIcon />}
                                                                </IconButton>
                                                                <Button onClick={() => ShowDeleteCausa(causa.id)} hidden={bloquearAcciones || contractData.legalInyectionSend}> <Trash2Icon style={{ marginLeft: '8px' }} /> </Button>
                                                            </>
                                                        </TableCell>
                                                    </TableRow>)
                                                })}

                                                <TableRow>
                                                    <TableCell colSpan={5}></TableCell>
                                                    <TableCell>
                                                        <>
                                                            <Button onClick={() => ShowAddCausa(linea.name, servicio.name, servicio.contractServiceId)} hidden={bloquearAcciones || contractData.legalInyectionSend}> Agregar Causa <CirclePlusIcon style={{ marginLeft: '8px' }} /> </Button>
                                                        </>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                            </Accordion>
                        ))}
                    </div>
                ))}

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panelSac-content" id="panelSac-header" >
                        TAREAS DE SAC
                    </AccordionSummary>
                    <AccordionDetails>
                        <Table>
                            {SAC_TASK?.map((task) => {
                                const isChecked = selectedTasks.some(selected => selected.name === task.name);
                                const selectedUser = selectedTasks.find(selected => selected.name === task.name)?.userId || 0;
                                const selectedExtra = selectedTasks.find(selected => selected.name === task.name)?.extra || "";

                                return (
                                    <tr key={task.name}>
                                        <td>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isChecked}
                                                        onChange={(e) => handleCheckboxChange(e, task)}
                                                        disabled={bloquearAcciones || contractData.legalInyectionSend}
                                                    />
                                                }
                                                label={`${task.name}`}
                                            />
                                        </td>
                                        <td>{`${task.description.slice(0, 60)}...`}</td>
                                        <td style={{ paddingRight: "10px" }}>
                                            <TextField
                                                label="Comentario"
                                                value={selectedExtra}
                                                onChange={(e) => handleExtraChange(e, task.name)}
                                                disabled={!isChecked || bloquearAcciones || contractData.legalInyectionSend}
                                                variant="outlined"
                                                fullWidth
                                                size='small'
                                            />
                                        </td>
                                        <td>
                                            <select
                                                value={selectedUser}
                                                onChange={(e) => handleUserChange(e, task.name)}
                                                disabled={!isChecked || bloquearAcciones || contractData.legalInyectionSend} // Deshabilita si la tarea no está seleccionada
                                            >

                                                {User_SAC?.map((user) => (
                                                    <option key={user.userId} value={user.userId}>
                                                        {user.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                );
                            })}
                        </Table>
                        <Grid item xs={12} >
                            <Button variant="contained" onClick={saveTask("sac")} hidden={bloquearAcciones || contractData.legalInyectionSend}>Guardar SAC</Button>
                        </Grid>
                    </AccordionDetails>
                </Accordion>


                {IsEEPP ?
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panelEepp-content" id="panelEepp-header" >
                            TAREAS DE EEPP
                        </AccordionSummary>
                        <AccordionDetails>

                            <Table>
                                {EEPP_TASK?.map((task) => {
                                    const isChecked = selectedTasksEEPP.some(selected => selected.name === task.name);
                                    const selectedUser = selectedTasksEEPP.find(selected => selected.name === task.name)?.userId || "";
                                    const selectedExtra = selectedTasksEEPP.find(selected => selected.name === task.name)?.extra || "";

                                    return (
                                        <tr key={task.name}>
                                            <td>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={isChecked}
                                                            onChange={(e) => handleCheckboxChangeEEPP(e, task)}
                                                            disabled={bloquearAcciones || contractData.legalInyectionSend}
                                                        />
                                                    }
                                                    label={`${task.name}`}
                                                />
                                            </td>
                                            <td>{`${task.description.slice(0, 60)}...`}</td>
                                            <td style={{ paddingRight: "10px" }}>
                                                <TextField
                                                    label="Comentario"
                                                    value={selectedExtra}
                                                    onChange={(e) => handleExtraChangeEEPP(e, task.name)}
                                                    disabled={!isChecked || bloquearAcciones || contractData.legalInyectionSend}
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            </td>
                                            <td>
                                                <select
                                                    value={selectedUser}
                                                    onChange={(e) => handleUserChangeEEPP(e, task.name)}
                                                    disabled={!isChecked || bloquearAcciones || contractData.legalInyectionSend} // Deshabilita si la tarea no está seleccionada
                                                >
                                                    <option value="" disabled>
                                                        Seleccione Usuario
                                                    </option>
                                                    {User_EEPP?.map((user) => (
                                                        <option key={user.userId} value={user.userId}>
                                                            {user.Name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </Table>
                            <Grid item xs={12} >
                                <Button variant="contained" onClick={saveTask("eepp")} hidden={bloquearAcciones || contractData.legalInyectionSend}>Guardar EEpp</Button>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    : null}
                <Button onClick={saveSetIsEEPP()} hidden={bloquearAcciones || contractData.legalInyectionSend}>
                    {IsEEPP ? "Quitar tareas EEPP" : "Agregar tareas EEPP"}
                </Button>

                {validarConteo() &&
                    (
                        contractData.hubspotInyectionSend == false ||
                        contractData.managerInyectionSend == false ||
                        contractData.legalInyectionSend == false ||
                        contractData.mailSends == false
                    )
                    ?
                    <Grid item xs={12} >
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            <Button
                                className='mt-2'
                                variant="contained"
                                color="success"
                                size="large"
                                endIcon={<CircleCheckBigIcon fontSize="inherit" />}
                                onClick={() => HandleInyeccion()}
                                disabled={bloquearAcciones}> Inyectar Contrato  </Button>
                        </Box>

                    </Grid>
                    :
                    (contractData.hubspotInyectionSend &&
                        contractData.managerInyectionSend &&
                        contractData.legalInyectionSend &&
                        contractData.mailSends) || validadoInyectado == true ?
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            <Button
                                className='mt-2'
                                variant="contained"
                                color="success"
                                size="large"
                                endIcon={<CircleCheckBigIcon fontSize="inherit" />}
                            //onClick={() => HandleInyeccion()} 
                            > Contrato Validado e Inyectado </Button>
                        </Box> :
                        <div className='w-100 d-flex justify-content-center'>
                            <Alert variant="danger" sx={{ mt: 3 }} className='text-align-start w-50'>Atencion!. Para validar e inyectar debe:
                                <div className='ms-5'>- Aprobar causas (debe crear obligatoriamente una si no existe)</div>
                                <div className='ms-5'>- Asignar tareas SAC (obligatorio)</div>
                                <div className='ms-5'>- EEPP (opcional)</div>
                            </Alert>
                        </div>
                }
                {/* MODAL PARA AGREGAR Informacion de la tarea */}
                <Modal show={show} size='xl' /*onHide={() => setShow(false)}*/ style={{ backgroundColor: 'rgba(93,213,209,0.3)' }} >
                    <Modal.Body> {openCausa ? <WorkFlowPage causa={openCausa} onclickWorkflowValidado={onclickWorkflowValidado} setShow={setShow} /> : null} </Modal.Body>
                </Modal>

                <Modal show={showInitialCase} size='xl' onClose={() => setShowInitialCase(false)} style={{ backgroundColor: "rgba(93,213,209,0.3)" }}>
                    <div style={{ background: "white", padding: "16px", borderRadius: "8px", width: "100%", margin: "auto" }}>
                        <Modal.Header>
                            <Modal.Title>Detalles de la Causa</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedCausa.causa ? (
                                <Box>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6} sm={6}>

                                            <p><strong>Rol:</strong> {selectedCausa.causa.rol}</p>
                                            <p><strong>Caratulado:</strong> {selectedCausa.causa.nombre}</p>
                                            <p><strong>Tribunal:</strong> {selectedCausa.causa.tribunal}</p>
                                            <p><strong>Demandante:</strong> {selectedCausa.causa.demandante}</p>
                                            <p><strong>Estado:</strong> {selectedCausa.causa.idStatus === 2 ? "Validada" : "Pendiente"}</p>


                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <h4>Seleccionar Grupo</h4>
                                            <Select
                                                //styles={{ control: (base) => ({ ...base, height: '56px' }) }}
                                                onChange={handleGroupChangeCase}
                                                options={grupos}
                                                className="basic-single mb-4"
                                                classNamePrefix="select"
                                                //defaultValue={colourOptions[0]}
                                                //isDisabled={false}
                                                //isLoading={searchServicio}
                                                value={grupos.find(group => group.value == getSelectedGroupId(selectedCausa.causa.id, selectedCausa.servicio)) ?? null}

                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={true}
                                            //name="color"
                                            />
                                        </Grid>
                                    </Grid>

                                    <div>
                                        {/* Lista de Tareas con Selección */}
                                        <hr />
                                        <h4>Seleccionar Tareas</h4>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Seleccionar</TableCell>
                                                    <TableCell>Tarea</TableCell>
                                                    <TableCell>Descripción</TableCell>
                                                    <TableCell >Comentario</TableCell>
                                                    <TableCell>Usuario Asignado</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {CASE_TASK?.map((task) => {
                                                    const key = `${selectedCausa.causa.id}-${selectedCausa.servicio}`;
                                                    const isChecked = selectedTasksCase[key]?.some((t) => t.name === task.name) || false;
                                                    const selectedUser = selectedTasksCase[key]?.find((t) => t.name === task.name)?.userId || "";
                                                    const selectedExtra = selectedTasksCase[key]?.find((t) => t.name === task.name)?.extra || "";

                                                    return (
                                                        <TableRow key={task.name}>
                                                            <TableCell>
                                                                <Checkbox
                                                                    checked={isChecked}
                                                                    onChange={(e) => handleCheckboxChangeCase(e, task, selectedCausa.causa.id, selectedCausa.servicio)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>{task.name}</TableCell>
                                                            <TableCell style={{ width: '25%' }}>{task.description}...</TableCell>
                                                            <TableCell style={{ width: '25%' }}>
                                                                <TextField
                                                                    label="Comentario"
                                                                    value={selectedExtra}
                                                                    onChange={(e) => handleExtraChangeCase(e, task.name, selectedCausa.causa.id, selectedCausa.servicio)}
                                                                    disabled={!isChecked}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    size='small'
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <select
                                                                    value={selectedUser}
                                                                    onChange={(e) => handleUserChangeCase(e, task.name, selectedCausa.causa.id, selectedCausa.servicio)}
                                                                    disabled={!isChecked}
                                                                >
                                                                    {User_CASES?.map((user) => (
                                                                        <option key={user.userId} value={user.userId}>
                                                                            {user.Name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </Box>
                            ) : (
                                <p>No hay causa seleccionada.</p>
                            )}
                        </Modal.Body>

                        {/* Botones */}
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                            <Button variant="contained" color="secondary" onClick={() => setShowInitialCase(false)}>
                                Cerrar
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleSave} style={{ marginLeft: "10px" }}>
                                Guardar Cambios
                            </Button>
                        </div>
                    </div>

                </Modal>

                <Modal show={showModalAddCausa} onHide={() => setShowModalAddCausa(false)} size='xl' style={{ backgroundColor: 'rgba(93,213,209,0.3)' }} >
                    <Modal.Header>
                        <Modal.Title>Agregar Causa</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    required
                                    id="rol"
                                    label="Rol"
                                    name="rol"
                                    value={newCase.rol}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    required
                                    id="nombre"
                                    label="Nombre Causa - Caratula"
                                    name="nombre"
                                    value={newCase.nombre}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    required
                                    id="demandante"
                                    label="Demandante"
                                    name="demandante"
                                    value={newCase.demandante}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    styles={{ control: (base) => ({ ...base, height: '56px' }) }}
                                    onChange={handleChangeTribunales}
                                    options={tribunales}
                                    className="basic-single mb-4"
                                    classNamePrefix="select"
                                    value={tribunales.find(opt => opt.value === newCase.codTribunal) ?? null}
                                    //defaultValue={colourOptions[0]}
                                    //isDisabled={false}
                                    //isLoading={searchServicio}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                //name="color"
                                />
                            </Grid>

                        </Grid>
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'right' }}>
                            <Button
                                type='submit'
                                sx={{ mr: 1 }}
                                variant="contained"
                                onClick={onClickAddCausa}
                                color="primary"
                                className="apple-button"
                                startIcon={<AddIcon />}
                            > Agregar </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setShowModalAddCausa(false)}
                                className="apple-button"
                                startIcon={<CloseIcon />}
                            > Cerrar </Button>
                        </Box>
                    </Modal.Body>
                </Modal>
            </Paper>
        </Fragment>
    )
}

export default ValidaForm   